<template>
  <div class="footer-container">
    <div class="footer1 main">
      <div class="left">
        <span>Contact Us</span>
        <div class="content">
          <el-image :src="require('@/assets/images/service.png')"></el-image>
          <div>
            <p>+65 88724595</p>
            <span>24h Unified hotline</span>
          </div>
        </div>
      </div>
      <!-- <div class="right">
        <div v-for="(item, index) in codeList" :key="index">
          <p class="title">{{ item.title || "" }}</p>
          <el-image
            :src="require('@/assets/images/' + item.img + '.png')"
          ></el-image>
          <p class="desc">{{ item.desc }}</p>
        </div>
      </div> -->
    </div>
    <div class="footer2">
      《SHOWALL PTE. LTD.》
      <!-- <a
        target="_blank"
        href="https://beian.miit.gov.cn/#/Integrated/index"
        >京ICP备19037663号-1</a
      > -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      codeList: [
        { title: "联系客服", img: "kefu", desc: "" },
        { title: "下载中心", img: "app", desc: "APP下载" },
        { title: "公众号二维码", img: "wechat", desc: "微信关注" },
        { title: "", img: "weibo", desc: "微博关注" }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.footer-container {
  background-color: #06080a;
  .footer1 {
    display: flex;
    justify-content: space-between;
    color: #fff;
    padding: 60px 0;
    .left {
      > span {
        font-weight: bold;
        font-size: 18px;
      }
      .content {
        margin-top: 30px;
        display: flex;
        align-items: center;
        .el-image {
          width: 40px;
          margin-right: 10px;
        }
        p {
          font-weight: bold;
          font-size: 18px;
        }
      }
    }
    .right {
      display: flex;
      .el-image {
        width: 75px;
        height: 75px;
      }
      > div {
        margin-left: 50px;
        text-align: center;
        .title {
          height: 30px;
        }
        .desc {
          font-size: 14px;
        }
      }
    }
  }
  .footer2 {
    border-top: 1px solid rgba(255, 255, 255, 0.25);
    text-align: center;
    line-height: 60px;
    color: rgba(255, 255, 255, 0.65);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/components/FooterMain.vue